import type { ApiRestTypes } from "@lobby/api-client";

export type RestPaymentMethod = ApiRestTypes.DefinitionMap["PaymentMethods.Method"];
export type RestPaymentCurrency = ApiRestTypes.DefinitionMap["PaymentMethods.CurrencyInfo"];
export type RestPaymentMethodsData = ApiRestTypes.DefinitionMap["PaymentMethods.Data"];

export function resolveDepositPaymentType(
  method: RestPaymentMethod,
): ApiRestTypes.DefinitionMap["PaymentRest.DepositPayload"]["type"] {
  return method.type === "crypto" ? "crypto" : "fiat";
}

export function getDepositCurrencies(
  currencies: RestPaymentCurrency[],
  depositType: "fiat" | "crypto" = "fiat",
): RestPaymentCurrency[] {
  return currencies.filter((currency) => currency.type === depositType);
}

export function resolveDepositCurrency(
  currencies: RestPaymentCurrency[],
  playerCurrency?: string | null,
): RestPaymentCurrency | null {
  const depositCurrencies = getDepositCurrencies(currencies);
  if (depositCurrencies.length === 0) {
    return null;
  }

  if (playerCurrency) {
    const playerMatch = depositCurrencies.find((currency) => currency.code === playerCurrency);
    if (playerMatch) {
      return playerMatch;
    }
  }

  return depositCurrencies[0] ?? null;
}

export function getDepositMethodsForCurrency(
  methods: RestPaymentMethod[],
  currencyCode: string,
): RestPaymentMethod[] {
  if (!currencyCode) {
    return [];
  }

  return methods.filter((method) => method.currencies[currencyCode]);
}

export function getMethodLimitsForCard(
  method: RestPaymentMethod,
  currencyCode: string,
): { min: number; max: number } | undefined {
  const methodCurrency = method.currencies[currencyCode];
  if (!methodCurrency?.limits) {
    return undefined;
  }

  return {
    min: Math.round(Number(methodCurrency.limits.min || "0") * 100),
    max: Math.round(Number(methodCurrency.limits.max || "0") * 100),
  };
}

export function getMethodCommission(method: RestPaymentMethod, currencyCode: string) {
  const methodCurrency = method.currencies[currencyCode];
  return methodCurrency.commission;
}
